import React from "react"
import { useHistory } from "react-router-dom"
import { getProviderFinderSearchURL, ProviderFinderParam } from "../../utils/providerFinderSearchUrl"
import { useUserContext } from "../../context/UserContext"
import { FormattedMessage, useIntl } from "react-intl"
import { Box, Checkbox, FormControl, FormControlLabel, FormHelperText } from "@carrotfertility/carotene-core"
import carrotPartnerIndicator from "../../resources/images/carrot-partner-indicator.svg"

export function CarrotPartnerFilter(): JSX.Element {
  const history = useHistory()
  const intl = useIntl()

  const params = new URLSearchParams(history.location.search)
  const currentCarrotPartnerSelection =
    params.has(ProviderFinderParam.CarrotPartner) && params.get(ProviderFinderParam.CarrotPartner) === "true"
  const { companyCountryCode } = useUserContext()

  const filterByCarrotPartner = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const newSearchURL = getProviderFinderSearchURL({
      searchLocation: params.get(ProviderFinderParam.Search),
      radiusInKm: params.get(ProviderFinderParam.RadiusInKm),
      companyCountryCode,
      locationDetails: {
        latitude: Number(params.get(ProviderFinderParam.Latitude)),
        longitude: Number(params.get(ProviderFinderParam.Longitude)),
        countryCode: params.get(ProviderFinderParam.Country),
        isBroadArea: false
      },
      carrotPartner: event.target.checked,
      providerType: params.get(ProviderFinderParam.ProviderType)
    })
    history.push({
      pathname: newSearchURL.pathname,
      search: newSearchURL.search
    })
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      padding={(theme) => theme.spacing(theme.tokens.spacing.sm)}
      sx={(theme) => ({
        backgroundColor: theme.palette.background.paper,
        borderRadius: theme.tokens.borderRadius.sm
      })}
    >
      <Box display="flex" flexDirection="column" gap={(theme) => theme.spacing(theme.tokens.spacing.md)}>
        <FormControl>
          <FormControlLabel
            label={
              <Box
                component="span"
                display="flex"
                flexDirection="row"
                alignItems="center"
                gap={(theme) => theme.spacing(theme.tokens.spacing.xxl)}
              >
                <FormattedMessage defaultMessage={`Carrot partners only`} />
                <img
                  src={carrotPartnerIndicator}
                  alt={intl.formatMessage({ defaultMessage: "Carrot Partner indicator" })}
                />
              </Box>
            }
            aria-label={intl.formatMessage({ defaultMessage: "Select carrot partner type" })}
            control={
              <Checkbox name="carrotPartner" checked={currentCarrotPartnerSelection} onChange={filterByCarrotPartner} />
            }
          />
          <FormHelperText>
            <FormattedMessage
              defaultMessage={`Carrot partner providers offer exclusive benefits like lower negotiated rates`}
            />
          </FormHelperText>
        </FormControl>
      </Box>
    </Box>
  )
}
